import { render, staticRenderFns } from "./weekGroup.vue?vue&type=template&id=0100a33e"
import script from "./weekGroup.vue?vue&type=script&lang=js"
export * from "./weekGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports